const mapLanguageValue = (language: string) => {
  switch (language) {
    case "zh-cn":
      return "zh-CN";

    case "zh-cht":
      return "zh-TW";

    case "vi":
      return "vi-VN";

    default:
      return `${language}-${language.toUpperCase()}`;
  }
};

export default mapLanguageValue;
